module.exports = __webpack_public_path__ + "img/trgl-4.414d81ee.svg";